import { useMutation, useQueryClient } from '@tanstack/react-query';

import { protocolosApi } from '../api';
import type { Protocolo } from '../types';
import { protocolosKeys } from './useProtocolos';

export function useActualizarCobrado() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uidProtocolo,
      cobrado,
    }: {
      uidProtocolo: string;
      cobrado: boolean;
    }) => protocolosApi.actualizarCobrado(uidProtocolo, { cobrado }),
    onSuccess: (updated: Protocolo) => {
      queryClient.setQueryData(protocolosKeys.detail(updated.uid_protocolo), updated);
      void queryClient.invalidateQueries({ queryKey: protocolosKeys.all });
    },
  });
}
